import * as z from "zod/v4";

export const startBalanceReload = {
  name: "startBalanceReload" as const,
  input: z.object({}),
  output: z.object({ balance: z.string() }),
};
